// extracted by mini-css-extract-plugin
export default {"headerWrapper":"PageHeader_headerWrapper__sUMTi","modalButtonsWrapper":"PageHeader_modalButtonsWrapper__Lkk9d"};